export function isNone(value: any) {
  return (
    !value &&
    (typeof value === 'undefined' || typeof value === 'object' || value === '')
  )
}
